import { Storage } from './s3Wrapper';
import { TAIForm } from 'src/types';

export const fetchAIForm = async (link: string): Promise<TAIForm> => {
  console.log('fetchAIForm: ' + link);
  const s3Url = await Storage.get(link, { level: 'public' });
  console.log('s3Url: ' + s3Url);
  return await fetch(s3Url).then((response) => response.json());
};
